export default __webpack_public_path__ + "static/media/mapaMG.0f9eefed.jpeg";